



/*	SELECTORS ==========================================================================	*/

	const $$ = (selector, element = document) => {

		return element.querySelector(selector);

	};

	const $ = (selector, element = document) => {

		return element.querySelectorAll(selector);

	};




/*	ADD REMOVE CLASS ==========================================================================	*/

	const addClass = (element, className) => {
		if (element && className) {
			element.classList.add(className);
		}
	};

	const removeClass = (element, className) => {
		if (element && className) {
			element.classList.remove(className);
		}
	};

	const hasClass = (element, className) => {
		if (!element || !className) return false;
		return element.classList.contains(className);
	};



/*	ARRAY ========================================================================== */

	const isInstanceOf = (elem, constructor) => elem instanceof constructor;

	const isArray = (value) => Array.isArray(value);
	const toArray = elem => isArray(elem) || isInstanceOf(elem, NodeList) ? elem : [elem];
	
	const ForEach = (array, callback) => array && toArray(array).forEach(callback);




/*	ATTRIBUTES ========================================================================== */

	const getAttr = (elem, attributeName) => elem?.getAttribute(attributeName);


	const setAttr = (elem, attributeObjects) => {
		elem && ForEach(attributeObjects,
			attrs => ForEach(Object.entries(attrs), ([name, value]) => elem?.setAttribute(name, value)))
	};


	const removeAttr = (elem, attributeNames) => {
		elem && ForEach(attributeNames, name => elem?.removeAttribute(name));
	};




/*	CREATE ELEMENT ==========================================================================	*/

	const createElement = (tag, attributes, content) => {

		const element = document.createElement(tag);
		setAttr(element, attributes);

		if (content) {
			element.innerHTML = content;
		}

		return element;
	};




/*	EVENT LISTENER ========================================================================== */

	const addEvent = (elements, eventNames, callback, capture = false) => {


		ForEach(eventNames, eventName => {
			ForEach(elements, element => {
				if (element) {
					element.addEventListener(eventName, callback, capture);
				}
			});
		});

	};


	const singleRemoveEvent = (elem, eventName, callback, capture = false) => {
		$(elem)?.removeEventListener(eventName, callback, capture);
	}

	const dispatchChangeEvent = (elem, event) => {
		const eventsubmit = new Event(event);
		elem.dispatchEvent(eventsubmit);
	};




/*	INTERSECTION OBSERVER ========================================================================== */

	const observeElements = (selector, callback, options) => {

		const observer = new IntersectionObserver((entries, observer) => {
		//	console.log( 'new entry!', entries[0].target );
			ForEach(entries, entry => callback(entry, observer));
		}, options);

		ForEach(selector, element => observer.observe(element));
	};





/*	COUNTUP NUMBERS ========================================================================== */

	const countUpNumbers = (entry, observer) => {
		if (!entry.isIntersecting) {
			return;
		}

		const element = entry.target;
		const targetAttr = JSON.parse(getAttr(element, 'data-anim-num'));
		const targetNum = parseInt(targetAttr['val']);
		const duration = 2000;

		let startNum = 0;
		let startTime = null;
		const prefix = targetAttr['prefix'] ?? '';
		const suffix = targetAttr['suffix'] ?? '';

		function stepAnim(timestamp) {
			if (!startTime) startTime = timestamp;
			const progress = Math.min((timestamp - startTime) / duration, 1);
			const currentNum = Math.floor(progress * (targetNum - startNum) + startNum);
			element.textContent = prefix + currentNum.toLocaleString(undefined, { maximumFractionDigits: 2 }) + suffix;
			if (progress < 1) {
				window.requestAnimationFrame(stepAnim);
			}
		}

		window.requestAnimationFrame(stepAnim);

		observer.unobserve(element);
	}




/*	CLASS BODY LOADING ========================================================================== */

	const pageAddLoading = (enableReSubmit = 0) => {
		console.log('pageAddLoading')
		addClass($$('body'), 'loading');
		
		SetTimeout(() => {
			pageRemoveLoading(enableReSubmit);
		}, 10000);
		
	};

	const pageRemoveLoading = (enableReSubmit = 1) => {

		removeClass($$('body'), 'loading');

		const spinner = $$('.spinner-border');

		if (spinner) {
			removeElement(spinner);
		}

		if (enableReSubmit) {

			ForEach($('[type="submit"]'), btnSubmit => {
				removeClass(btnSubmit, 'disabled');
			});


			ForEach($('fieldset.form'),	fieldset => {
				removeAttr(fieldset, 'disabled');
			});

			ForEach($('.add-item'),	addItem => {
				removeAttr(addItem, 'disabled');
			});

			ForEach($('[contenteditable]'),	contenteditable => {
				setAttr(contenteditable, {contenteditable:true});
			});

		}
	};




/*	FETCH ========================================================================== */

	const postData = async (url = "", data = null) => {

		const fetchOption = {
				method: "POST",
				mode: "same-origin",
				cache: "no-cache",
				credentials: "same-origin",
				redirect: "follow",
				referrerPolicy: "strict-origin-when-cross-origin",
				body: data,
			};

		try {

			const options = (data) ? fetchOption : {}
			const response = await fetch(url, options);

			if (response.ok) {
				return response.json();
			} else {
				return { success: 0, error: 1 };
			}
		} catch (error) {
			console.error('There was a problem with the fetch operation:', error.message);
			return { success: 0, error: 1 };
		}
	};




/*	UTILITIES ========================================================================== */


	const scrollIntoViewOffset = (selector, offset = 110) => {

		const scrollPosition = window.scrollY || window.pageYOffset;

		if (selector && scrollPosition !== undefined) {
			window.scrollTo({
				behavior: 'smooth',
				top: selector.getBoundingClientRect().top - document.body.getBoundingClientRect().top - offset,
			})

		}
	}

	const appendChild = (parent, child) => {
		parent.appendChild(child);
	};

	const removeElement = (element) => {
		element?.remove();
	};

	const getCurrentTarget = (event) => {
		return event.currentTarget;
	};

	const innerHTML = (element, message) => {
		element.innerHTML = message;
	};

	const elemDisplay = (element, value) => {
		element.style.display = value;
	};

	const insertBeforeElement = (parent, newElement, referenceElement) => {
		parent.insertBefore(newElement, referenceElement);
	};


	const closestParent = (child, parent) => {
		return child.closest(parent);
	};



/*	DRAGGABLE ========================================================================== */


	let dragSrcEl = null;
	let enterCounter = new WeakMap();
	let touchStartX, touchStartY;
	let currentHoveredElement = null; // Track the currently hovered element


	const getClosestDraggable = function (element) {
		if (element) {
			return element.closest('[draggable="true"]');
		}
		return null;
	};


	const handleTouchStart = function (e) {
		dragSrcEl = getClosestDraggable(e.target);
		if (dragSrcEl) {
			touchStartX = e.touches[0].clientX;
			touchStartY = e.touches[0].clientY;
		}
	};

	const handleTouchMove = function (e) {
		if (!dragSrcEl) return;


		if (shouldPreventDefault(e)) {
			e.preventDefault();
		}

		const target = document.elementFromPoint(e.touches[0].clientX, e.touches[0].clientY);
		const closestTarget = getClosestDraggable(target);


		if (currentHoveredElement && currentHoveredElement !== closestTarget) {
			currentHoveredElement.classList.remove('over');
			enterCounter.set(currentHoveredElement, 0);
		}


		if (closestTarget && closestTarget !== dragSrcEl) {
			if (!enterCounter.has(closestTarget)) {
				enterCounter.set(closestTarget, 0);
			}
			enterCounter.set(closestTarget, enterCounter.get(closestTarget) + 1);
			closestTarget.classList.add('over');
			currentHoveredElement = closestTarget; // Update the currently hovered element
		}
	};


	const shouldPreventDefault = function (e) {
		const touch = e.touches[0];
		const element = document.elementFromPoint(touch.clientX, touch.clientY);
		return element && element.classList.contains('icon-arrows-up-down-left-right');
	};

	const handleTouchEnd = function (e) {
		if (!dragSrcEl) return;

		const target = document.elementFromPoint(e.changedTouches[0].clientX, e.changedTouches[0].clientY);
		const dropTarget = getClosestDraggable(target);

		if (dragSrcEl !== dropTarget && dropTarget) {
			const draggableItems = Array.from(document.querySelectorAll('[draggable="true"]'));
			const dragIndex = draggableItems.indexOf(dragSrcEl);
			const dropIndex = draggableItems.indexOf(dropTarget);

			if (dragIndex < dropIndex) {
				dropTarget.parentNode.insertBefore(dragSrcEl, dropTarget.nextSibling);
			} else {
				dropTarget.parentNode.insertBefore(dragSrcEl, dropTarget);
			}
		}

		draggableItems.forEach(item => {
			item.classList.remove('over');
			enterCounter.set(item, 0);
		});

		dragSrcEl = null; // Reset the dragged element
		currentHoveredElement = null; // Reset the currently hovered element
	};


	const handleDragStart = function (e) {
		dragSrcEl = this;
		e.dataTransfer.effectAllowed = 'move';
		e.dataTransfer.setData('text/plain', '');
	};

	const handleDragOver = function (e) {
		if (e.preventDefault) {
			e.preventDefault();
		}
		e.dataTransfer.dropEffect = 'move';
		return false;
	};

	const handleDragEnter = function (e) {
		let target = getClosestDraggable(e.target);
		if (target && target !== dragSrcEl) {
			if (!enterCounter.has(target)) {
				enterCounter.set(target, 0);
			}
			enterCounter.set(target, enterCounter.get(target) + 1);
			target.classList.add('over');
		}
	};

	const handleDragLeave = function (e) {
		let target = getClosestDraggable(e.target);
		if (target && target !== dragSrcEl) {
			enterCounter.set(target, enterCounter.get(target) - 1);
			if (enterCounter.get(target) === 0) {
				target.classList.remove('over');
			}
		}
	};

	const handleDrop = function (e) {
		if (e.stopPropagation) {
			e.stopPropagation();
		}

		let target = getClosestDraggable(e.target);
		if (dragSrcEl !== target && target) {
			const draggableItems = Array.from(document.querySelectorAll('[draggable="true"]'));
			const dragIndex = draggableItems.indexOf(dragSrcEl);
			const dropIndex = draggableItems.indexOf(target);

			if (dragIndex < dropIndex) {
				target.parentNode.insertBefore(dragSrcEl, target.nextSibling);
			} else {
				target.parentNode.insertBefore(dragSrcEl, target);
			}
		}
		return false;
	};

	const handleDragEnd = (e) => {
		ForEach(draggableItems, item => {
			item.classList.remove('over');
			enterCounter.set(item, 0);
		});
		dragSrcEl = null; // Reset the dragged element
		currentHoveredElement = null; // Reset the currently hovered element
	};

	const addDraggable = (element) => {

	    addEvent(element, 'dragstart', handleDragStart);
	    addEvent(element, 'dragenter', handleDragEnter);
	    addEvent(element, 'dragover', handleDragOver);
	    addEvent(element, 'dragleave', handleDragLeave);
	    addEvent(element, 'drop', handleDrop);
	    addEvent(element, 'dragend', handleDragEnd);
	    addEvent(element, 'touchstart', handleTouchStart);
	    addEvent(element, 'touchmove', handleTouchMove);
	    addEvent(element, 'touchend', handleTouchEnd);

	}

	let draggableItems = $('[draggable="true"]');
	addDraggable(draggableItems);





/*	UPLOAD FILE ========================================================================== */


	const uploadFile = (elem) => {



		const xhr = new XMLHttpRequest();

		const submitBtn = $$('[type="submit"]');
		if (submitBtn) {
			submitBtn.disabled = true;
		}
		

		const container = elem.parentElement.previousElementSibling;
		let progressBar, progressText;
		const label = elem.nextElementSibling;

		$$('span',label)?.remove();
		progressText = createProgressText();
		label.appendChild(progressText);

		addClass(label, 'disabled');

		xhr.upload.onprogress = (e) => handleUploadProgress(e, progressText, elem);
		xhr.onload = () => {
			if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
				const data = JSON.parse(xhr.response);

				if (data.success) {

					if (data.redirect) {
					
						window.location.href = data.redirect;

					} else {

					}

				} else {
					 handleFileError(elem, label, progressText, submitBtn);
				}
				console.log(data)
			}
		};

		xhr.upload.onerror = () => handleFileError(elem, label, progressText, submitBtn);
		xhr.upload.onabort = () => handleFileError(elem, label, progressText, submitBtn);
		xhr.onerror = () => handleFileError(elem, label, progressText, submitBtn);

		const formData = createFormData(elem);
		xhr.open('POST', '/forms-user/import', true);
		xhr.send(formData);

	};

	const handleFileError = (elem, label, progressText, submitBtn) => {
		progressText.textContent = getAttr(elem, 'data-error');
		removeClass(label, 'disabled');
		elem.value = '';
		if (submitBtn) {
			submitBtn.disabled = false;
		}
	};




/*	UPLOAD IMAGE ========================================================================== */


	const uploadImage = (elem) => {

		const xhr = new XMLHttpRequest();
		const uploadFolder = location.host.startsWith("sandbox") ? '/uploads-sandbox/' : '/uploads/';
		const isMultiple = elem.hasAttribute('multiple');

		const submitBtn = $$('[type="submit"]');
		submitBtn.disabled = true;

		const container = elem.parentElement.previousElementSibling;
		let progressBar, progressText;
		const label = elem.nextElementSibling;

		if (isMultiple) {


			$$('span',label)?.remove();
			progressText = createProgressText();
			label.appendChild(progressText);

		} else {

			[progressBar, progressText] = createProgressBar();
			$$('.progress-text',container)?.remove();
			container.appendChild(progressBar);
		}

		addClass(label, 'disabled');

		xhr.upload.onprogress = (e) => handleUploadProgress(e, progressText, elem);
		xhr.onload = () => handleUploadLoad(xhr, elem, container, label, progressBar, progressText, submitBtn, isMultiple, uploadFolder);
		xhr.upload.onerror = () => handleUploadError(elem, label, progressText, submitBtn);
		xhr.upload.onabort = () => handleUploadError(elem, label, progressText, submitBtn);
		xhr.onerror = () => handleRequestError(elem, label, progressText, submitBtn);

		const formData = createFormData(elem);
		xhr.open('POST', '/forms-user/upload', true);
		xhr.send(formData);

	};




/*	UPLOAD FILES UTILITIES ========================================================================== */


	const createProgressText = () => {
		const progressText = createElement('span', {class: 'badge bg-secondary white-space-normal ms-1 p-2'});
		return progressText;
	};

	const createProgressBar = () => {
		const progressBar = createElement('div', {class: 'progress-text bg-light bg-opacity-50'});

		const progressText = createElement('div', {class: 'badge bg-secondary white-space-normal p-2'});
		progressBar.appendChild(progressText);

		return [progressBar, progressText];
	};

	const handleUploadProgress = (e, progressText, elem) => {
		if (e.lengthComputable) {
			const progressVal = (e.loaded / e.total) * 100;
			progressText.textContent = (progressVal > 99) ? getAttr(elem, 'data-progress') : `${Math.round(progressVal)}%`;
		}
	};

	const handleUploadLoad = (xhr, elem, container, label, progressBar, progressText, submitBtn, isMultiple, uploadFolder) => {
		if (xhr.readyState === XMLHttpRequest.DONE && xhr.status === 200) {
			const data = JSON.parse(xhr.response);
			console.log(data);
			if (data.success) {
				if (isMultiple) {
					handleMultipleUploadSuccess(data, container, elem, label, progressText, uploadFolder);
				} else {
					handleSingleUploadSuccess(data, container, elem, label, progressBar, uploadFolder);
				}
			} else {
				handleUploadError(elem, label, progressText, submitBtn);
			}
		}
		if (!$('label.disabled').length) {
			submitBtn.disabled = false;
		}
	};

	const handleMultipleUploadSuccess = (data, container, elem, label, progressText, uploadFolder) => {

		let images = data.src;
		if (typeof images === 'object' && images !== null) {
			images = Object.values(images);
		}
		images.forEach(src => {
			const imgContainer = createElement('div', {draggable: 'true'});

			const imgDiv = createElement('div', {class: 'img-multiple'});

			const imgTag = createElement('img', {class: 'img-fluid img-thumbnail', src:`${uploadFolder}${src}.jpg` });

			const imgBtnDelete = createElement('button', {type: 'button', class: 'delete-img btn btn-danger top-0 start-0 position-absolute z-1 icon-trash'});

			const imgBtnMove = createElement('button', {type: 'button', class: 'btn btn-light text-secondary bottom-0 end-0 position-absolute z-1 icon-arrows-up-down-left-right'});

			const imgInput = createElement('input', {type: 'hidden', name: `${data.inputName}[]`, value: src});

			imgDiv.append(imgTag, imgBtnDelete, imgBtnMove, imgInput);
			imgContainer.appendChild(imgDiv)
			container.appendChild(imgContainer);
			let draggableItems = $('[draggable="true"]');
			addDraggable(imgContainer);

		});
		progressText.remove();
		removeClass(label, 'disabled');
		elem.value = '';
	};

	const handleSingleUploadSuccess = (data, container, elem, label, progressBar, uploadFolder) => {
		$$('img', container).src = `${uploadFolder}${data.src[0]}.jpg`;
		$$('input', container).value = data.src[0];
		progressBar.remove();
		removeClass(label, 'disabled');
		elem.value = '';
	};

	const handleUploadError = (elem, label, progressText, submitBtn) => {
		progressText.textContent = getAttr(elem, 'data-error');
		removeClass(label, 'disabled');
		elem.value = '';
		if (!$('label.disabled').length) {
			submitBtn.disabled = false;
		}
	};

	const handleRequestError = (elem, label, progressText, submitBtn) => {
		console.error('Request error');
		handleUploadError(elem, label, progressText, submitBtn);
	};

	const createFormData = (elem) => {
		const formData = new FormData();
		const files = elem.files;
		const imgSizes = getAttr(elem,'data-img-size');
		const importType = getAttr(elem,'data-import');

		Array.from(files).forEach(file => {
			formData.append(`${elem.name}[]`, file);
			formData.append('inputName[]', elem.name);
		});


		formData.append('NONCE', $$('#NONCE').value);
		formData.append('HASH', $$('#HASH').value);
		formData.append('URL', $$('#URL').value);
		if (imgSizes) {
			formData.append('sizes', imgSizes);
		}
		if (importType) {
			formData.append('import-type', importType);
		}
		return formData;
	};



/*	MODAL ========================================================================== */



	const createModalElements = (sectionElem, elemConfig) => {


		ForEach(elemConfig, item => {
			for (const tag in item) {
				const { attr, content } = item[tag];
				appendChild(sectionElem, createElement(tag, attr, content));
			}
		});
	};

	const createModalContent = (htmlConfig) => {
		const fragment = document.createDocumentFragment();
		for (const section in htmlConfig) {
			const sectionElem = createElement('div', { class: section });
			createModalElements(sectionElem, htmlConfig[section]);
			appendChild(fragment, sectionElem);
		}
		return fragment;
	};

	const createModal = async (config) => {
		const modal = createElement('div', { class: 'modal fade', tabindex: '-1' });
		const modalSize = config.modalSize ?? '';
		const modalDialog = createElement('div', { class: 'modal-dialog modal-dialog-centered modal-dialog-scrollable '+modalSize });
		const modalContent = createElement('div', { class: 'modal-content' });
		let modalInnerContent;

		if (config.fetchUrl) {

			pageAddLoading();

			try {

				let postBody = {};

				if (config.formdata) {
					const formData = new FormData();
					formData.append('NONCE', config.formdata.NONCE);
					formData.append('HASH', config.formdata.HASH);
					formData.append('URL', config.fetchUrl);
					postBody = formData
				}

			const data = await postData(config.fetchUrl, postBody);

			if (data.success) {

				modalInnerContent = data.modal.content;
				if (data.modal.modalSize) {
					addClass(modalDialog, data.modal.modalSize);
				}

			} else {
				if (data.error) {
					modalInnerContent = data.error;
				}
				if (data.message) {
					modalInnerContent = data.message;
				}
			}
			console.log(data);
			} catch (error) {
				modalInnerContent = data.error;
				console.log('catch error');
			}

			pageRemoveLoading();

		} else {

			modalInnerContent = config.modal;

		}


		const htmlContent = createModalContent(modalInnerContent);

		appendChild(modalContent, htmlContent);
		appendChild(modalDialog, modalContent);
		appendChild(modal, modalDialog);

		appendChild(document.body, modal);


		const bootstrapModal  = new bootstrap.Modal(modal);

		bootstrapModal .show();
		addEvent(modal, ['hidden.bs.modal'], () => {
			removeElement(modal);
		});

	};



/*	TIMEOUT, PREVENT DEFAULT ========================================================================== */


	const SetTimeout = (callback, delay) => setTimeout(callback, delay);

	const preventDefault = event => event.preventDefault();



/*	FORM HANDLE ERROR ========================================================================== */

	const handleError = (formElem, submitButton, alertmsg, data, spinner) => {

		addClass(formElem, 'was-error');
		pageRemoveLoading();

		if (data.message && alertmsg) {
			removeClass(alertmsg, 'alert-success');
			addClass(alertmsg, 'alert-danger');
			innerHTML(alertmsg, data.message)
			elemDisplay(alertmsg,'block')

			if (typeof data.noScroll === 'undefined') {
				scrollIntoViewOffset(alertmsg);
			}
		}



		/*
		if ($('#delete_post')) {
			enableFormInputs();
			$('#delete_post').remove();
		}
		*/
	};



/*	RENAME CLONE VARIANT ========================================================================== */

	const renameCloneVariant = () => {

		const variant = $('.product-variant');
		let cloneIndex = 0;

		ForEach(variant, group => {


			ForEach($('input, select, textarea, label',group), elem => {

				const label = elem.getAttribute('for');

				if (label) {
					setAttr(elem, {for: label.replace(/\[\d+\]/, `[${cloneIndex}]`)} );
				}
				if (elem.name) {
					elem.name = elem.name.replace(/\[\d+\]/, `[${cloneIndex}]`);
				}
				if (elem.id) {
					elem.id = elem.id.replace(/\[\d+\]/, `[${cloneIndex}]`);
				}
			});

			cloneIndex++;

		});

		deleteBtnVariant();
	}




/*	SHOW DELETE BTN VARIANT ========================================================================== */

	const deleteBtnVariant = () => {

		const variant = $('.product-variant');
		let Index = 0;

		ForEach(variant, group => {

			const btnDelete = $$('.delete-item', group);
			const itemID = $$('input', group);

			if (Index > 0) {
				if (hasClass(btnDelete,'enable-delete')) {

					removeAttr(btnDelete, 'style');

				} else {
					if (!itemID.value) {
						removeAttr(btnDelete, 'style');
					}
				}
				

			} else {
				elemDisplay(btnDelete, 'none');
			}

			Index++;

		});

	}



/*	GOOGLE CAPTCHA ========================================================================== */

	function onSubmit(token) {
		dispatchChangeEvent($$('form'), 'submit');
	}




/*	EVENTS DOM LOADED ====================================================================== */

	const rootMarginPX = '0px 0px -10% 0px'

	addEvent(document, ["DOMContentLoaded"], event => {




/*	TRANSITION ========================================================================== */

	ForEach(['.fadeIn','.fadeInUp','.fadeInLeft','.fadeInRight'], elem => observeElements($(elem), (entry, observer) => {

		if (entry.isIntersecting) {
			const element = entry.target;
			addClass(element, 'active');
			observer.unobserve(element);
		}

		},

		{ rootMargin: rootMarginPX } 

	));

	observeElements($('[data-anim-num]'), countUpNumbers, { rootMargin: rootMarginPX });


	const fragment = window.location.hash;
	if (fragment && $$(fragment)) {

		const targetElement = $$(fragment);

		if (targetElement) {
			window.location.hash = '';
			scrollIntoViewOffset(targetElement);
		}
	}



/*	BODY LOADING ========================================================================== */

	pageRemoveLoading();

	let triggerbeforeunload = true;

	addEvent($('a'), 'click', event => {

		const elem = getCurrentTarget(event);
		const href = getAttr(elem,'href');

		if (href) {

			if (href == '#') {

				preventDefault(event);

				if (hasClass(elem,'history-back')) {
					history.back();
				}
				

			} else {

				if (!getAttr(elem,'target')) {
					pageAddLoading();

				} else {

					triggerbeforeunload = false;
				}
			}
		}
	});

	/*
		addEvent($('.history-back'), ['click'], event => {
			pageAddLoading();
			history.back();
		});
	*/

	addEvent(window, ['beforeunload'], event => {
		if (triggerbeforeunload) {
			pageAddLoading();
		}
		
	});


	if (document.referrer.indexOf(window.location.host) === -1 || document.referrer == '') {
		ForEach($('.history-back'), elem => setAttr(elem, {disabled:true}))
	}




/*	TOOLTIP ========================================================================== */

	const tooltipTriggerList = $('[data-bs-toggle="tooltip"]')
	const tooltipList = [...tooltipTriggerList].map(tooltipTriggerEl => new bootstrap.Tooltip(tooltipTriggerEl))




/*	LOWERCASE ========================================================================== */
	addEvent($('.js-lowercase'), 'change', event => {

		const elem = event.currentTarget;
		const str = elem.value;
		elem.value = str.toLowerCase();

	});




/*	REMOVE SPACE ========================================================================== */
	addEvent($('.js-nospace'), 'change', event => {
		
		const elem = event.currentTarget;
		const str = elem.value;
		elem.value = str.replace(/\s+/g, '');

	});




/*	TIKTOK EMBED ========================================================================== */

	const dataFetch = 'data-fetch';
	ForEach($('['+dataFetch+']'), elem => {

		if (elem) {

			const config = JSON.parse(getAttr(elem, dataFetch));

			try {
				postData('https://www.tiktok.com/oembed?url=https://vt.tiktok.com/' + config.url).then((data) => {

					// TIKTOK
					if (config.type == 'tiktok') {
						if (data.embed_product_id) {

							const iframe = createElement('iframe', {src: 'https://www.tiktok.com/player/v1/'+data.embed_product_id, allow: 'fullscreen'});
							elem.appendChild(iframe);

						} else {
							elem.remove();
						}
					}


				//	console.log(data);
				});

			} catch (error) {
				console.log(error)

			}
			

		}

	});




/*	MODAL ========================================================================== */

	const dataModal = 'data-modal-config';
	addEvent($('['+dataModal+']'), ['click'], event => {
		const elem = event.currentTarget;

		const config = JSON.parse(getAttr(elem, dataModal));

		createModal(config);

	});




/*	SLIDESHOW ========================================================================== */

	addEvent($$('#carousel'), ['slide.bs.carousel'], event => {

		const img_counter = $$('#img-counter');
		if (img_counter) {
			img_counter.innerText = event.to + 1;
		}
	});




/*	SHOPPING CART ========================================================================== */



	addEvent($('.input-qty'), ['change'], event => {

		const elem = event.currentTarget;
		let input_value = parseInt(elem.value);
		let max_amount = parseInt(getAttr(elem,'data-max'));

		if (max_amount < 1) {
			max_amount = 0;
		}

		if (isNaN(input_value)) {
			input_value = 0;
		}

		let total_value = input_value;

		if (total_value < 1) {
			elem.value = '';
		}

		if (total_value > max_amount) {
			elem.value = max_amount;
			if (max_amount == 0) {
				elem.value = '';
			}

			const tooltipInstance = bootstrap.Tooltip.getInstance(elem.nextElementSibling);
			tooltipInstance.show();
			setTimeout(() => {
				tooltipInstance.hide();
			}, 800);
		}


		// CALCULATE

		let subTotal = 0;
		ForEach($('.input-qty'), input => {
			subTotal += input.value * parseFloat(getAttr(input,'data-price'));
		});

		$$('#total-amount').innerText = new Intl.NumberFormat().format(subTotal);

	});


	addEvent($('.add-qty'), ['click'], event => {

		const elem = event.currentTarget;

		const inputElem = $$('input', elem.parentNode);
		let input_value = parseInt(inputElem.value);

		let amount = 1;

		if (isNaN(input_value)) {
			input_value = 0;
		}

		if (hasClass(elem, 'cart-minus')) {
			amount = -1;
		}

		inputElem.value = input_value + amount;
		dispatchChangeEvent(inputElem, 'change');


	});




/*	FORM NEXT SECTION BUTTON ========================================================================== */

	const formSections = $('section');

	const formNav = $('.form-page-nav');

	let newIndex = 0;
	let storedIndex = 0;

	if (formNav.length) {

		ForEach(formNav, formBtn => {

			addEvent(formBtn, 'click', event => {

				const pgNumber = (formBtn.id == 'next-form') ? 1 : -1;
				newIndex = storedIndex + pgNumber;

				if (formSections[newIndex]) {
					storedIndex = newIndex;
					scrollIntoViewOffset(formSections[newIndex], 60);
				}

			});
		});
	}




/*	HTML EDITOR ========================================================================== */

	/*
	const toolbarOptions = [
		['bold', 'italic', 'underline', 'strike'],        // toggled buttons
		['blockquote', 'code-block'],
		['link', 'image', 'video', 'formula'],

		[{ 'header': 1 }, { 'header': 2 }],               // custom button values
		[{ 'list': 'ordered'}, { 'list': 'bullet' }, { 'list': 'check' }],
		[{ 'script': 'sub'}, { 'script': 'super' }],      // superscript/subscript
		[{ 'indent': '-1'}, { 'indent': '+1' }],          // outdent/indent
		[{ 'direction': 'rtl' }],                         // text direction

		[{ 'size': ['small', false, 'large', 'huge'] }],  // custom dropdown
		[{ 'header': [1, 2, 3, 4, 5, 6, false] }],

		[{ 'color': [] }, { 'background': [] }],          // dropdown with defaults from theme
		[{ 'font': [] }],
		[{ 'align': [] }],

		['clean']                                         // remove formatting button
	];
	*/


	ForEach($('.js-htmleditor'), editor => {

		const elemID = '#'+ getAttr(editor, 'data-id');

		const quill = new Quill(editor, {
			modules: {
				toolbar: elemID + '-htmltoolbar',
			},
			formats: ['header', 'bold', 'italic', 'underline', 'list', 'link'],
		});

		quill.on('text-change', (delta, oldDelta, source) => {

			let content = quill.root.innerHTML.replace('<p><br></p>' ,'');
			if (content === '<p><br></p>') {
				content = '';
			}
			$$(elemID).value = content;
		});


	});




/*	FORM SUBMIT POST ========================================================================== */


	ForEach($('form'),form => {

		let alertmsgOrginalText = '';

		if (form.method.toLowerCase() === 'get') return;

		addEvent(form, 'submit', (event) => {

			preventDefault(event);

			const formElem = getCurrentTarget(event);

			const alertmsg = $$('.alert-msg');

			if (alertmsg) {
				if (!alertmsgOrginalText) {
					alertmsgOrginalText = alertmsg.innerHTML;
				}
				removeAttr(alertmsg, 'style')
			};

			if (!formElem.checkValidity()) {

				console.log('checkValidity');

				addClass(formElem, 'was-validated');
				removeClass(formElem, 'was-error');

				innerHTML(alertmsg, alertmsgOrginalText)
				elemDisplay(alertmsg,'block')

				const inputInvalid = $$('input:invalid, select:invalid, textarea:invalid', formElem);
			//	console.log(closestParent(inputInvalid, '.form-page'));
				scrollIntoViewOffset(inputInvalid);

			} else {

				pageAddLoading();

				const submitButton = $$('button[type="submit"]', formElem);
				addClass(submitButton, 'disabled');
				
				const spinner = createElement('span', {class: 'spinner-border spinner-border-sm me-2'});
				const spinnerExist = $$('.spinner-border', submitButton);
				if (!spinnerExist) {
					insertBeforeElement(submitButton, spinner, submitButton.firstChild);
				}

				removeClass(formElem, 'was-error');

				const formData = new FormData(formElem);

				const fileInputs = formElem.querySelectorAll('input[type="file"]');
				fileInputs.forEach(fileInput => {
					Array.from(fileInput.files).forEach(file => {
						formData.append(fileInput.name+'[]', file);
					});
				});

				ForEach($('fieldset.form'),	fieldset => {
					setAttr(fieldset, {disabled:true});
				});


				ForEach($('.add-item'),	addItem => {
					setAttr(addItem, {disabled:true});
				});

				ForEach($('[contenteditable]'),	contenteditable => {
					setAttr(contenteditable, {contenteditable:false});
				});

				try {
					postData(formElem.action, formData).then((data) => {

						if (data.success) {

							const removeSubmit = data.resubmit ?? 0;

							removeClass(formElem, 'was-error');

							if (data.message && alertmsg) {
								removeClass(alertmsg, 'alert-danger');
								addClass(alertmsg, 'alert-success');
								innerHTML(alertmsg, data.message)
								elemDisplay(alertmsg,'block');
							}


							if (data.redirect) {
							
								window.location.href = data.redirect;

								if (data.download) {
									pageRemoveLoading(removeSubmit);
								}

							} else {

								
								pageRemoveLoading(removeSubmit);

								if (typeof data.noScroll === 'undefined') {
									scrollIntoViewOffset(alertmsg);
								}
								
								if (data.checkout) {
									console.log(data.checkout);
									var rzp = new Razorpay(data.checkout);
									rzp.open();
								}

							}

						} else {

							handleError(formElem, submitButton, alertmsg, data, spinner);

						}
						console.log(data);

					});

				} catch (error) {

					console.log(error);
					handleError(formElem, submitButton, alertmsg, {message: alertmsgOrginalText}, spinner);

				}


			}

		});
	});




/*	FORM SUBMIT GET ========================================================================== */

	ForEach($('.change-submit'), select => {
		addEvent(select, 'change', function(event) {
			pageAddLoading();
			getCurrentTarget(event).closest('form').submit();
		});
	});

	ForEach($('.click-submit'), elem => {
		addEvent(elem, 'click', function(event) {
			pageAddLoading();
			getCurrentTarget(event).closest('form').submit();
		});
	});

	ForEach($('.click-submit-fetch'), elem => {
		addEvent(elem, 'click', function(event) {
			pageAddLoading();
			const submit = $$('[type="submit"]');
			if (submit) {
				submit.click();
			}
		});
	});

	ForEach($('.click-clear'), elem => {
		addEvent(elem, 'click', function(event) {
			pageAddLoading();
			const thisElem = getCurrentTarget(event);
			thisElem.nextSibling.value = '';
			thisElem.closest('form').submit();
		});
	});



	addEvent($$('#email_members'), 'change', function(event) {
		const thisElem = getCurrentTarget(event);
		const email = $$('#email');
		const name = $$('#name');
		if (thisElem.value) {
			email.value = name.value = '';
			email.disabled = true;
			name.disabled = true;
		} else {
			email.disabled = false;
			name.disabled = false;
		}
	});


	addEvent($('.limit-check'), 'change', function(event) {
		const thisElem = getCurrentTarget(event);
		const limit = parseInt(getAttr(thisElem, 'data-limit'));
		const name = getAttr(thisElem, 'name');
		const inputName = 'input[name="'+ name + '"]';
		if ($(inputName + ':checked').length > limit) {
			thisElem.checked = false;
		}
	});


	ForEach($('input[name="donate_option"]'), item => {
		addEvent(item, 'change', function(event) {
			const elemValue = item.value;
			const donateAmount = $$('#donate-amount');
			if (elemValue > 0) {
				donateAmount.value = elemValue;
			} else {
				donateAmount.value = '';
				donateAmount.focus();
			}
			dispatchChangeEvent(donateAmount, 'change');
		});
	});

	addEvent($$('#donate-amount'), ['change','keyup'], function(event) {
		let elemValue = parseInt(event.target.value);
		if (isNaN(elemValue)) {
			elemValue = 0;
		}
		const donateBtn = $$('#donate-btn');
		if (elemValue > 0) {
			removeAttr(donateBtn, 'disabled');
		} else {
			setAttr(donateBtn, {disabled: 'disabled'});
		}

		const donateBtnOther = $$('#donate-other');
		if (event.type == 'keyup' && !donateBtnOther.checked) {
			donateBtnOther.checked = true;
		}
	});


	let orgText = null;
	addEvent($$('input[name="same_as_shipping"]'), 'change', function(event) {
		const elem = event.target;
		const label = elem.nextElementSibling;

		orgText = orgText ?? label.innerText;
		label.innerText = getAttr(elem,'data-text');

		ForEach(['address','postal_code','city','state'], name => {
			$$('[name="' + name + '_shipping"]').value = $$('[name="' + name + '"]').value;
		});

		SetTimeout(() => {
			elem.checked = false;
			label.innerText = orgText
		}, 750);
	});




/*	UPLOAD IMAGES ========================================================================== */

	if ($('.upload-container').length) {

		let imgToRemove = null;

		addEvent(document, ['change'], function(event) {

			const elem = event.target;
			const acceptType = getAttr(elem,'accept');

			if (elem && elem.type == 'file' && acceptType) {

				if (acceptType == "image/*") {
					uploadImage(elem);

				} else if (acceptType == ".csv") {
					uploadFile(elem);
					console.log('csv')
				}

			}
		});

		addEvent(document, ['click'], function(event) {

			const elem = event.target.closest('button');

			if (elem) {

				if (hasClass(elem, 'remove-img')) {

					imgToRemove = elem.closest('.upload-single').parentElement;

					const getConfirm = JSON.parse(getAttr($$('#remove-img'),'data-reconfirm'));

					createModal(getConfirm);
				}

				if (elem.id == 'remove-img') {

					if (imgToRemove) {

						ForEach($('input',imgToRemove), inputElem => {
							inputElem.value = '';
						});
						const imgPic = $$('img',imgToRemove);

						imgPic.src = getAttr(imgPic,'data-img-org');

						removeElement($$('.progress-text'),imgToRemove);

						imgToRemove = null;

					}
				}

				if (elem.id == 'no-remove-img') {
					imgToRemove = null;
				}
			}

		});
	}




/*	DYNAMIC: DELETE IMAGES ========================================================================== */

	if ($('.upload-multiple').length) {

		let imgToDelete = null;

		addEvent(document, ['click'], function(event) {

			// DELETE
			const elem = event.target;

			if (elem) {

				if (hasClass(elem,'delete-img')) {

					imgToDelete = elem.closest('[draggable="true"]');

					const getConfirm = JSON.parse(getAttr(elem.closest('[data-confirm]'),'data-confirm'));

					createModal(getConfirm);


				}

				if (elem.id == 'delete-img') {
					if (imgToDelete) {
						imgToDelete.remove();
						imgToDelete = null;
					}
				}

				if (elem.id == 'no-delete-img') {
					imgToDelete = null;
				}

			}

		});

	}




/*	ADD VARIATION ========================================================================== */

	addEvent($$('.add-item'), 'click', (event) => {

		console.log('add-variant');
		const fieldset = $$('.product-variant');
		const cloneditem = fieldset.cloneNode(true);

		ForEach($('input, option, textarea, img, label', cloneditem), elem => {

			if (elem.tagName.toLowerCase() === 'input' || elem.tagName.toLowerCase() === 'textarea') {
				if (elem.type === 'checkbox' || elem.type === 'radio') {
					elem.checked = false;
				} else {
					elem.value = '';
				}
			}

			if (elem.tagName.toLowerCase() === 'option') {
				elem.selected = false;
			}

			if (elem.tagName.toLowerCase() === 'img') {
				elem.src = getAttr(elem, 'data-img-org');
				removeElement($$('.progress-text', elem.parentElement));
			}

			if (elem.tagName.toLowerCase() === 'label' && hasClass(elem, 'disabled')) {
				removeClass(elem, 'disabled')
			}
		});

		fieldset.parentNode.insertBefore(cloneditem, $$('.add-item'));

		renameCloneVariant();

		scrollIntoViewOffset(cloneditem)

	});




/*	DELETE BTN VARIANT ========================================================================== */

	if ($('.delete-item').length) {

		deleteBtnVariant();

		addEvent(document, ['click'], function(event) {

			const elem = event.target;

			if (hasClass(elem,'delete-item')) {

				elem.closest('.product-variant').remove();

			}
		})
	}




/*	CHARTJS ========================================================================== */

	const datachartjs = 'data-chartjs';


	if ($('['+ datachartjs +']').length) {

		Chart.register(ChartDataLabels);
		Chart.register(ChartDeferred);

		ForEach($('['+ datachartjs +']'), elem => {

			if (elem) {

				const configchartjs = JSON.parse(getAttr(elem, datachartjs));

				let callbackLabelFunc = null;

				if (configchartjs?.options?.plugins?.tooltip?.callbacks?.label) {
					callbackLabelFunc = configchartjs.options.plugins.tooltip.callbacks.label;
				}

				if (callbackLabelFunc) {
					configchartjs.options.plugins.tooltip.callbacks.label = eval('(' + callbackLabelFunc + ')');
				}

				let dataLabelsFormatter = null;

				if (configchartjs?.options?.plugins?.datalabels?.formatter) {
					dataLabelsFormatter = configchartjs.options.plugins.datalabels.formatter;
				}

				if (dataLabelsFormatter) {
					configchartjs.options.plugins.datalabels.formatter = eval('(' + dataLabelsFormatter + ')');
				}

				if (configchartjs.type == 'bar') {

					const maxDataValue = Math.max(...configchartjs.data.datasets[0].data);
					const buffer = maxDataValue * 0.05;
					configchartjs.options.scales.y.suggestedMax = maxDataValue + buffer;
					configchartjs.options.scales.y.min = 0;
					configchartjs.options.scales.y.max = Math.max(...configchartjs.data.datasets[0].data) + buffer;

					configchartjs.options.scales.y.ticks = {
						callback: function(value) {
							if (value > maxDataValue) {
								return '';
							}
							return value;
						}
					}

				}

				configchartjs.options.plugins.deferred = {
					yOffset: '80%',
					delay: 100
				};

				const myChart = new Chart(elem, configchartjs);

			}

		});

		

	}


/*	QR CODE ========================================================================== */

	const videoElem = $$('#qr-video');

	if (videoElem) {
		console.log(videoElem)


		const resultElem = $$('#qr-message');

		import('/js/qr-scanner.min.js').then((module) => {

			const QrScanner = module.default;

			const qrScanner = new QrScanner(videoElem, result => {

				console.log('QR Code detected:', result);
				resultElem.textContent = getAttr(resultElem,'data-msg');
				removeClass(resultElem, 'text-bg-secondary');
				addClass(resultElem, 'text-bg-primary');
				$$('#qr-result').value = result.data;
			//	alert(result.data);
				onSubmit(null);
				qrScanner.stop();

			}, {

				highlightScanRegion: true,
				highlightCodeOutline: true
			});

			qrScanner.start().then(() => {

				console.log('QR Scanner started.');

			}).catch(error => {

				console.error('QR Scanner failed to start:', error);
				resultElem.textContent = `Error: ${error}`;
				removeClass(resultElem, 'text-bg-secondary');
				removeClass(resultElem, 'active');
				addClass(resultElem, 'text-bg-danger');
			//	$$('#qr-result').value = 'result.data';
			//	onSubmit(null);
			});


			window.addEventListener('unload', () => {
				qrScanner.stop();
			});


		});

	}





/*	============================== INSTALL APP ============================================================== */


	let deferredPrompt;

	window.addEventListener('beforeinstallprompt', (event) => {

		event.preventDefault();

		deferredPrompt = event;

		addEvent($('.installAndroid'), 'click', () => {

			deferredPrompt.prompt();

			deferredPrompt.userChoice.then((choiceResult) => {
				if (choiceResult.outcome === 'accepted') {
					console.log('User accepted the A2HS prompt');
				} else {
					console.log('User dismissed the A2HS prompt');
				}
				deferredPrompt = null;
			});
		});
	});

	window.addEventListener('appinstalled', (event) => {
		console.log('Web app installed successfully');
	});







/*	============================== WINDOW LOAD ============================================================== */

	const availLang = $$('#avail-lang');

	if (availLang) {

		window.onload = function() {

			if(typeof google !== 'undefined') {

				const currentlang = document.documentElement.lang;

				new google.translate.TranslateElement({
				//	pageLanguage: currentlang,
					includedLanguages: getAttr(availLang, 'data-avail-lang'),
				//	autoDisplay: false,
				//	multilanguagePage: true,
				}, 'gTranslate');

				let checkCount = 0;
				const checkInterval = setInterval(() => {
					let combo = $$('.goog-te-combo');

					if (combo && combo.value != currentlang) {

						combo.value = currentlang;
						dispatchChangeEvent(combo, 'change');
						clearInterval(checkInterval);
					} else if (combo && combo.value == currentlang) {
						clearInterval(checkInterval);
					}
					checkCount++;
					console.log(combo.value, currentlang)
					console.log(checkCount)
				}, 1000);

				SetTimeout(() => {
					clearInterval(checkInterval);
				}, 5000);

			}

		}

	}	




/*	============================== DOM END ============================================================== */
	});







